import { idbCache } from '@ribajs/cache'
import { version } from '../../../package.json'

class CacheService {
  private _cache = idbCache

  public get cache(): typeof idbCache {
    return this._cache
  }

  public getUncachedVersion(): string {
    return version
  }

  public async getCachedVersion(): Promise<string> {
    return (await this._cache.resolve('version')) || ''
  }

  public setCachedVersion(version: string): void {
    this._cache.resolve('version', version)
  }

  public async clear(): Promise<void> {
    await this._cache.clear()
  }

  public async init(): Promise<{
    cachedVersion: string
    uncachedVersion: string
  }> {
    const cachedVersion = await this.getCachedVersion()
    const uncachedVersion = this.getUncachedVersion()
    // clear cache if version is different
    if (cachedVersion !== uncachedVersion) {
      console.debug(
        '[CacheService] Clear cache because version is different',
        cachedVersion,
        uncachedVersion,
      )
      await this.clear()
    }

    this.setCachedVersion(uncachedVersion)
    return {
      cachedVersion,
      uncachedVersion,
    }
  }
}

const cacheService = new CacheService()

cacheService
  .init()
  .then(({ uncachedVersion }) => {
    console.info(
      '[CacheService] CacheService initialized with version ' + uncachedVersion,
    )
  })
  .catch(error => {
    console.error('[CacheService] Error initializing CacheService', error)
  })

export { cacheService }
